import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from '../../../app/state/app.selectors';
import * as fromPaymentCredit from './payment-credit.reducers';

export interface PaymentCreditState {
  stateData: fromPaymentCredit.State;
}

export interface State extends fromRoot.AppState {
  paymentCredit: PaymentCreditState;
}

export const reducers = {
  stateData: fromPaymentCredit.reducer
};

export const selectPaymentCreditState = createFeatureSelector<PaymentCreditState>('paymentCredit');

export const selectPaymentCreditStateData = createSelector(selectPaymentCreditState, (state: PaymentCreditState) => state.stateData);


export const getPaymentCreditFormCCState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateFormCCData);

export const getProcessedPaymentCreditFormCCState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateProcessedFormCCData);


export const getPaymentCreditFormCGState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateFormCGData);

export const getProcessedPaymentCreditFormCGState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateProcessedFormCGData);


export const getPaymentCreditFormPPState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateFormPPData);

export const getProcessedPaymentCreditFormPPState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateProcessedFormPPData);


export const getPaymentCreditScreenError = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getError);

export const getPaymentCreditScreenPending = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getPending);


export const getPaymentCreditFormESState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateFormESData);

export const getProcessedPaymentCreditFormESState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateProcessedFormESData);




// export const getPaymentCreditFormCIState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateFormCIData);

// export const getProcessedPaymentCreditFormCIState = createSelector(selectPaymentCreditStateData, fromPaymentCredit.getStateProcessedFormCIData);